import { ILocalization } from '../../../localization/definitions/types';
import { GeneralAppSettings } from '../../types';

export enum GeneralAppSettingsType {
    GET_GENERAL_APP_SETTINGS = 'GET_GENERAL_APP_SETTINGS',
    UPDATE_GENERAL_APP_SETTINGS = 'UPDATE_GENERAL_APP_SETTINGS',
    GET_LOGO_IMAGE_URL = 'GET_LOGO_IMAGE_URL',
}

interface GetGeneralAppSettingsAction {
    type: GeneralAppSettingsType.GET_GENERAL_APP_SETTINGS;
    payload: GeneralAppSettings;
    localization: ILocalization;
}

interface UpdateGeneralAppSettingsAction {
    type: GeneralAppSettingsType.UPDATE_GENERAL_APP_SETTINGS;
    payload: GeneralAppSettings;
    localization: ILocalization;
}

interface GetLogoImageAction {
    type: GeneralAppSettingsType.GET_LOGO_IMAGE_URL;
    payload: string;
}

export type GeneralAppSettingsAction =
    | GetGeneralAppSettingsAction
    | UpdateGeneralAppSettingsAction
    | GetLogoImageAction;
